import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Payload } from './dc-alert-model';

@Injectable({
  providedIn: 'root',
})
export class DcAlertService {
  protected alertTypeSource = new Subject();

  alertType$ = this.alertTypeSource.asObservable();

  showAlert(payload: Payload) {
    this.alertTypeSource.next(payload);
  }

  success(message: string): void {
    this.showAlert({ type: 'success', message });
  }

  danger(message: string): void {
    this.showAlert({ type: 'danger', message });
  }
}
